// MITI 4.2.1, H. SUMMARY SCORES, pp. 32–33.
export function calculateSummaryScores(globalRatings, behaviorCounts) {
    const r = Object.fromEntries(globalRatings.map(item => [item.label, item.score]));
    const c = Object.fromEntries(behaviorCounts);
    const reflections = c['단순 반영'] + c['복합 반영'];
    return {
        technical: (r['변화대화 촉진'] + r['유지대화 완화']) / 2,
        relational: (r['파트너십'] + r['공감']) / 2,
        complexPercent: reflections > 0 ? c['복합 반영'] / reflections * 100 : null,
        reflectionQuestionRatio: c['질문'] > 0 ? reflections / c['질문'] : null,
        adherent: c['협력 구하기'] + c['인정'] + c['자율성 강조'],
        nonAdherent: c['직면'] + c['설득'],
    };
}
